#import "../fragments/saved-list-stub-fragment.graphql"

query GetSavedFilters(
    $type: SavedFiltersReportType
    $includeShared: Boolean
    $ignoreUserFilters: Boolean
    $sort: SavedFilterSortType
    $searchNameQuery: String
) {
    savedFilters(
        type: $type
        includeShared: $includeShared
        sort: $sort
        ignoreUserFilters: $ignoreUserFilters
        searchNameQuery: $searchNameQuery
    ) {
        edges {
            node {
                ...SavedListStubFragment
            }
        }
    }
}
